"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), function (p) {
  return p.marginBottom;
});

var StyledTitle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.25;\n"])), function (props) {
  return props.isSmall ? "0.25rem" : "0.325rem";
}, function (props) {
  return props.isSmall ? "0.875rem" : "1.0625rem";
}, function (p) {
  return p.theme.fontFamilyDefault;
});

var StyledSubtitle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  font-family: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.25;\n"])), function (props) {
  return props.isSmall ? "0.75rem" : "0.875rem";
}, function (props) {
  return props.theme.colorLabel;
}, function (p) {
  return p.theme.fontFamilyDefault;
});

var TitleStack = function TitleStack(_ref) {
  var isSmall = _ref.isSmall,
      title = _ref.title,
      subtitle = _ref.subtitle,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    marginBottom: marginBottom,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      isSmall: isSmall,
      children: title
    }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubtitle, {
      isSmall: isSmall,
      children: subtitle
    })]
  });
};

TitleStack.defaultProps = {
  isSmall: false,
  marginBottom: "1rem"
};
TitleStack.propTypes = {
  isSmall: _propTypes.default.bool,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  marginBottom: _propTypes.default.string
};
var _default = TitleStack;
exports.default = _default;